import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  footer: {
    flex: '0 1 auto',
    borderTop: `1px solid ${theme.evPalette.charcoal[400]}`,
    height: 'fit-content',
    backgroundColor: theme.evPalette.salt[100],
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    padding: '10px',
    zIndex: 200,
    marginTop: 'auto',
    '& >*': {
      fontFamily: theme.typography.fontFamily,
      fontSize: '10px',
      fontWeight: 400,
      lineHeight: '12px',
      letterSpacing: 0,
      textAlign: 'left',
      color: theme.evPalette.charcoal[800],
    },
    '@media (max-width: 640px)': {
      borderTop: '0px',
    },
  },
  footerLinksContainer: {
    width: '100%',
    whiteSpace: 'nowrap',
    color: theme.evPalette.charcoal[900],
    '& a': {
      textDecoration: 'none',
      color: theme.evPalette.ocean[600],
    },
    marginRight: '30px',
    '@media (min-width: 640px)': { width: 'fit-content' },
  },
  footerDisclaimerText: {
    fontSize: '10px',
    width: '90%',
    alignSelf: 'center',
    '@media (min-width: 640px)': {
      width: 'auto',
      flex: '1 1 0',
    },
  },
  expandedMenuLink: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  footerDisclaimerContainer: {
    display: 'flex',
    flex: '1 1 0',
    justifyContent: 'space-between',
  },
  footerIcon: {
    height: '20px',
    width: '20px',
  },
}));
